import React, { useState } from "react";

export const permissionNames =
[
    'Create',
    'Read',
    'Update',
    'Delete'
];

/**
 * @typedef CrudTogglesButtonProperties
 * @property {string} icon
 * @property {string} title
 * @property {number} roleId
 * @property {number} permissionObjectId
 * @property {number} permissionKind
 * @property {IPermissionMatrix} matrix
 * @property {(roleId: number, permissionObjectId: number, permissionKind: number, next: boolean) => void} onToggle
 */

/**
 * @param {CrudTogglesButtonProperties} param0
 */
export function CrudTogglesButton({ icon, title, roleId, permissionObjectId, permissionKind, matrix, onToggle })
{
    const [active, setActive] = useState(() => matrix.has(roleId, permissionObjectId, permissionKind));
    const [dirty, setDirty] = useState(() => matrix.isDirty(roleId, permissionObjectId, permissionKind));
    const cls = `crud-icon ${active ? 'active' : ''} ${dirty ? 'dirty' : ''} ${icon}`;
    /** @type {React.MouseEventHandler} */
    const handleClick = e =>
    {
        e.stopPropagation();
        const next = !active;
        setActive(next);
        onToggle(roleId, permissionObjectId, permissionKind, next);
        setDirty(matrix.isDirty(roleId, permissionObjectId, permissionKind));
    };
    const element =
    <i
        className={cls}
        title={title}
        role="button"
        aria-label={title}
        onClick={handleClick}
    />;
    return element;
}

const icons =
[
    'fa fa-plus',
    'fa fa-eye',
    'fa fa-pen',
    'fa fa-trash'
];

/**
 * @typedef CrudTogglesProperties
 * @property {number} roleId
 * @property {number} permissionObjectId
 * @property {IPermissionMatrix} matrix
 * @property {(roleId: number, permissionObjectId: number, permissionKind: number, next: boolean) => void} onToggle
 */

/**
 * @param {CrudTogglesProperties} props
 */
export function CrudToggles({ roleId, permissionObjectId, matrix, onToggle })
{
    const buttons = [];
    for (const permissionKind of [0, 1, 2, 3])
    {
        if (matrix.hasPermissionKind(permissionObjectId, permissionKind))
        {
            buttons.push
            // eslint-disable-next-line no-unexpected-multiline
            (
                <CrudTogglesButton
                    roleId={roleId}
                    permissionObjectId={permissionObjectId}
                    permissionKind={permissionKind}
                    matrix={matrix}
                    onToggle={onToggle}
                    icon={icons[permissionKind]}
                    title={permissionNames[permissionKind]}
                />
            );
        }
    }
    return <div className="crud-cell">{buttons}</div>;
}